@if (patientAttachment.contentProcessing) {
  <div
    class="alert mb-1"
    [class.alert-warning]="requiresRefresh"
    [class.alert-info]="!requiresRefresh">
    <div class="row">
      <div class="col-auto d-flex align-items-center">
        @if (requiresRefresh) {
          <mat-icon class="alert-icon text-warning">
            warning
          </mat-icon>
        }
        @if (!requiresRefresh) {
          <mat-icon class="info-icon">
            info
          </mat-icon>
        }
      </div>
      <div class="col d-flex align-items-center">
        @if (requiresRefresh) {
          <p class="m-0">
            The system has completed processing this document!
          </p>
        }
        @if (!requiresRefresh) {
          <p class="m-0">
            The system is processing this document.
          </p>
        }
      </div>
      <div class="col actions">
        <button
          class="btn btn-primary"
          [class.invisible]="!requiresRefresh"
          [disabled]="refreshing"
          (click)="onRefreshClick()">
          @if (refreshing) {
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true">
            </span>
          }
          Refresh
        </button>
      </div>
    </div>
  </div>
}
